import { createMultiStyleConfigHelpers, ComponentStyleConfig } from '@chakra-ui/react';
import { modalAnatomy } from '@chakra-ui/anatomy';

const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(modalAnatomy.keys);

const baseStyle = definePartsStyle({
  overlay: {
    bg: 'utility.500',
    _dark: {
      bg: 'blackAlpha.500'
    }
  },
  dialog: {
    borderRadius: 'xl'
  },
  header: {
    pl: 8,
    pr: 14,
    pt: 6
  },
  body: {
    px: 8
  },
  footer: {
    px: 8,
    pb: 6
  },
  closeButton: {
    top: 6,
    insetEnd: 6
  }
});

export const modalTheme: ComponentStyleConfig = defineMultiStyleConfig({
  baseStyle
});
